<template>
  <router-view />
  <CookieBanner v-if="$route.path != '/contact-2'" />

  <iframe
    v-if="showChatbot"
    src="https://chatbot.aipath.gr/"
    id="chatIframer"
    data-loaded="false"
    title="AiPath AI assistant"
    loading="lazy"
    referrerpolicy="strict-origin-when-cross-origin"
    allow="clipboard-write"
    @load="handleChatLoad"
    @error="handleChatError"
  ></iframe>
</template>

<script>
/* eslint-disable */
import CookieBanner from "./components/common/CookieBanner.vue";
import "../src/assets/css/iframeStyling.css";
export default {
  name: "App",
  components: {
    CookieBanner,
  },
  data() {
    return {
      chatOrigin: "https://chatbot.aipath.gr",
      chatClosedSize: "120px",
      chatDesktopWidth: "600px",
      chatDesktopHeight: "698px",
    };
  },
  computed: {
    showChatbot() {
      return this.$route.path !== "/contact-2";
    },
  },
  watch: {
    $route() {
      this.$nextTick(this.applyChatSize);
    },
  },
  mounted() {
    window.addEventListener("message", this.handleMessageFromIframe);
    window.addEventListener("resize", this.applyChatSize);
    this.$nextTick(this.applyChatSize);
  },
  beforeUnmount() {
    window.removeEventListener("message", this.handleMessageFromIframe);
    window.removeEventListener("resize", this.applyChatSize);
  },
  methods: {
    getChatFrame() {
      return document.getElementById("chatIframer");
    },
    isChatClosed() {
      return sessionStorage.getItem("chatClosed") !== "false";
    },
    setChatClosed(iframe) {
      iframe.style.height = this.chatClosedSize;
      iframe.style.width = this.chatClosedSize;
      sessionStorage.setItem("chatClosed", "true");
    },
    setChatOpen(iframe) {
      if (window.innerWidth < 600) {
        iframe.style.height = "100svh";
        iframe.style.width = "100%";
        return;
      }

      iframe.style.height = window.innerHeight < 698 ? "100%" : this.chatDesktopHeight;
      iframe.style.width = this.chatDesktopWidth;
    },
    applyChatSize() {
      const iframe = this.getChatFrame();
      if (!iframe) return;

      if (this.isChatClosed()) {
        this.setChatClosed(iframe);
      } else {
        this.setChatOpen(iframe);
      }
    },
    handleMessageFromIframe(event) {
      if (event.origin !== this.chatOrigin) return;
      if (!event.data || typeof event.data.action !== "string") return;

      const iframe = this.getChatFrame();
      if (!iframe) return;

      if (event.data.action === "openChat") {
        sessionStorage.setItem("chatClosed", "false");
        this.setChatOpen(iframe);
      }

      if (event.data.action === "closeChat") {
        setTimeout(() => {
          this.setChatClosed(iframe);
        }, 300);
      }
    },
    handleChatLoad(event) {
      event.target.dataset.loaded = "true";
      this.applyChatSize();
    },
    handleChatError(event) {
      event.target.dataset.loaded = "false";
    },
  },
};
</script>


